var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"package-size"},[_vm._v(" Max. "+_vm._s(_vm.length)+"mm (L) "),(_vm.width)?_c('span',[_vm._v("x "+_vm._s(_vm.width)+"mm (W)")]):_vm._e(),(_vm.depth)?_c('span',[_vm._v("x "+_vm._s(_vm.depth)+"mm (D)")]):_vm._e(),(_vm.note)?_c('span',[_vm._v(_vm._s(_vm.note))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }